import authModule from "../../../utilities/AuthModule";
import { IFileToUpload } from "../interfaces/IFileToUpload";
import { BasePersistor } from "./BasePersistor";
import { API } from "../config/constants";
import { SavingLocationState } from "../types";
import { CheckinTypes, IFileSaveResult, ListSettings } from "../components/_v2/redux/api/local/api-local-interfaces";
import { FileMetaData } from "../interfaces/props/FileMetaData";
import { IFileSystemUploadData } from "../interfaces/IFileSystemUploadData";
import { IFileSystemFolder } from "../../../utilities/DragAndDropHelper";
import { OneDriveUrlHelper } from "../components/helpers/oneDriveUrlHelper";
import { apiFileSystemCallDynamicEndpoint } from "./ApiService";
import { SaveMode } from "../components/enums/SaveModeEnum";

export class FileSystemEntryPersistor extends BasePersistor {

  saveToSharepoint = async (
    isOneDrive: boolean,
    selectedFiles: IFileToUpload[],
    folderEntriesToUpload: IFileSystemFolder[],
    savingLocation: SavingLocationState,
    autoFolderCreation: boolean,
    fileMetaData: FileMetaData[],
    accountId: string,
    informationProtectionId: string,
    tenantOcrLanguage?: string,
    tenantReplaceFileNameWithGUID?: boolean,
    listSettings?: ListSettings,
    checkinType?: CheckinTypes,
    ensureUniqueFileName?: boolean,
    saveMode?: SaveMode,
    convertEmailToPDF?: boolean
  ): Promise<any> => {
    const userAuthData = await authModule.getAuthData();
    if (!userAuthData || !userAuthData.account) {
      authModule.signOut();
      return null;
    }

    const filesToUpload: IFileToUpload[] = selectedFiles.filter(file => file.originalName && file.isFileSystemEntry && !file.isFolder && !file.cancelled);
    if (filesToUpload.length > 0) {
      const foldersToUpload: IFileSystemFolder[] = folderEntriesToUpload.filter(f => folderEntriesToUpload.some(folder => folder.parentFolderId && f.id === folder.parentFolderId) || filesToUpload.some(file => file.parentFolderId && f.id === file.parentFolderId));

      let dataToSend: IFileSystemUploadData = {
        sharepointInfo: {
          graphToken: userAuthData.graphToken,
          sharepointToken: isOneDrive ? userAuthData.oneDriveToken : userAuthData.sharePointToken,
          // informationProtectionToken: userAuthData.informationProtectionToken,
          // mailToken: null,
          siteUrl: isOneDrive ? OneDriveUrlHelper.getSiteUrl(savingLocation.webUrl) : savingLocation.webUrl,
          documentLibrary: savingLocation.documentLibrary,
          sharepointListId: savingLocation.sharePointListId,
          sharePointUniqueId: savingLocation.sharePointUniqueId,
          directory: isOneDrive
            ? savingLocation.directory
              ? `${OneDriveUrlHelper.initialDocumentLibrary}/${savingLocation.directory}`
              : OneDriveUrlHelper.initialDocumentLibrary
            : savingLocation.directory,
          autoFolderCreation: autoFolderCreation,
          ensureUniqueFileName,
          checkinType: checkinType,
        },
        saveMode: saveMode,
        // Honors the tenant convertEmailToPDF setting for dragged Outlook emails; the
        // backend converts only .eml message entries (attachments keep their format).
        convertEmailToPDF: convertEmailToPDF === true,
        folders: foldersToUpload,
        fileContents: filesToUpload,
        fileMetadataList: fileMetaData.map(file => {
          return {
            fileId: file.fileId,
            metaData: this.mapFileMetadata(file)
          }
        }),
        tenantGuid: userAuthData.account.tenantId,
        accountId: accountId,
        username: userAuthData.account.username,
        sensitivityLabelId: informationProtectionId,
        tenantOcrLanguage: tenantOcrLanguage,
        tenantReplaceFileNameWithGUID: tenantReplaceFileNameWithGUID,
        listSettings,
        teamId: savingLocation.teamId,
        channelId: savingLocation.channelId
      };

      return await apiFileSystemCallDynamicEndpoint(API.url.fileSystem.sharepoint, false, dataToSend);
    }
    else {
      return {
        success: true,
        message: "",
        succeededFiles: [],
        failedFileNames: []
      } as IFileSaveResult;
    }
  };
}
